import { z } from "zod";
export const PAYMENT_PROVIDERS = ["stripe", "swikly"];
export const paymentProviderSchema = z.enum(PAYMENT_PROVIDERS);
export const PaymentProviderEnum = {
    STRIPE: "stripe",
    SWIKLY: "swikly",
};
